import classNames from 'classnames'
import PropTypes from 'prop-types'
import classes from './ProfileOverview.module.scss'

import ProfileAvatar from '../../../../common/avatar/ProfileAvatar'

import { ReactComponent as MailIcon } from '../../../../../assets/images/common/icons/mail-icon.svg'
import { ReactComponent as WarningIcon } from '../../../../../assets/images/common/icons/warning-icon.svg'

import { genderLabel } from '../../../../../utility/userHelper'

const INVITATION = {
  active: {
    label: 'Invited',
    icon: <MailIcon className={classes.invitedIcon} />,
  },
  expired: {
    label: 'Invitation Expired',
    icon: <WarningIcon className={classes.expiredIcon} />,
  },
}

const ProfileOverview = ({ student, invitationStatus }) => (
  <article className={classes.container}>
    <ProfileAvatar student={student} />
    <div className='d-flex flex-column justify-content-center'>
      <header className={classes.title}>
        <span className={classes.studentName}>{student.fullName}</span>
        {!!invitationStatus && invitationStatus !== 'not_found' && (
          <span className={classes.invitationLabel}>
            {INVITATION[invitationStatus].icon}
            <span
              className={
                classNames({
                  [classes.invitedText]: invitationStatus === 'active',
                  [classes.expiredText]: invitationStatus === 'expired',
                })
              }
            >
              {INVITATION[invitationStatus].label}
            </span>
          </span>
        )}
      </header>
      <span className={classes.studentInfo}>
        {`Age ${student.age ?? '-'} / `}
        {genderLabel[student.gender].at(0)}
      </span>
    </div>
  </article>
)

ProfileOverview.propTypes = {
  student: PropTypes.shape({
    fullName: PropTypes.string,
    age: PropTypes.number,
    gender: PropTypes.number,
  }),
  invitationStatus: PropTypes.string,
}

export default ProfileOverview
